import React from 'react';

import { HashDialog } from '../../../../../shared/components/dialog/HashDialog';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';

import { IParkingProduct } from '../../../../domain/parking-product/models/IParkingProduct';
import { ParkingProductDetailsDialog } from './ParkingProductDetailsDialog';

export const PARKING_PRODUCT_DETAILS_DIALOG_HASH_PATTERN =
	'#details/:parkingProductId';

interface IParkingProductDetailsDialogRouteProps {
	onSelectProduct: (parkingProduct: IParkingProduct) => void;
}

export const ParkingProductDetailsDialogRoute = ({
	onSelectProduct,
}: IParkingProductDetailsDialogRouteProps) => {
	const { t } = useTranslation();

	return (
		<HashDialog
			hash={PARKING_PRODUCT_DETAILS_DIALOG_HASH_PATTERN}
			ariaLabel={t('parking_product_details_dialog_label')}
			replaceStateOnClose
			allowPinchZoom
		>
			<ParkingProductDetailsDialog onSelectProduct={onSelectProduct} />
		</HashDialog>
	);
};
